<template>
  <div class="custom-control custom-checkbox">
    <input type="checkbox" class="custom-control-input" :id="name" :name="name" v-model="localValue" />
    <label class="custom-control-label" :for="name">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'BaseCheckbox',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    localValue: null
  }),
  created() {
    this.localValue = this.value
  },
  watch: {
    value() {
      this.localValue = this.value
    },
    localValue() {
      this.$emit('input', this.localValue)
    }
  }
}
</script>
